<template>
    <div class="detail">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="576px" :before-close="handleClose">
            <div class="form" v-loading="load">
                <el-form label-width="110px" label-position="left" v-if="info">
                    <el-form-item label="活动名称:">
                        <p>{{ info.title }}</p>
                    </el-form-item>
                    <el-form-item label="发货人姓名:">
                        <p>{{ info.sender_name }}</p>
                    </el-form-item>
                    <el-form-item label="发货人手机号:">
                        <p>{{ info.sender_cellphone }}</p>
                    </el-form-item>
                    <el-form-item label="地区:">
                        <p>{{ `${info.province}${info.city}${info.district}${info.address}` }}</p>
                    </el-form-item>
                    <el-form-item label="创建时间:">
                        <p>{{ info.create_time }}</p>
                    </el-form-item>
                    <el-form-item label="更新时间:">
                        <p>{{ info.update_time }}</p>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            info: null,
            load: false,
        };
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    methods: {
        ...mapActions({
            warehouseDetail: "brand/warehouseDetail",
        }),
        getDetail(id) {
            this.load = true;
            let params = {
                token: this.getToken,
                id: id,
            };
            this.warehouseDetail(params).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.info = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.info = null;
        },
    },
};
</script>

<style lang="scss" scoped>
.form {
    min-height: 350px;
}
</style>